<template>
  <AppDialog
    append-to-body
    :show="show"
    size="large"
    :title="title"
    @close="closeDialog"
  >
    <div
      v-if="isLoading"
      class="d-flex align-items-center justify-content-center p-20"
    >
      <div class="spinner-wrapper absolute">
        <span class="hi hi-spinner hi-32 text-blue" />
      </div>
    </div>
    <div
      v-else
      class="insights-work-time-expenditure-dialog relative"
    >
      <AppChartStackedHorizontal
        :chart-id="`${widgetKey}-horizontal`"
        class="d-flex align-items-end"
        :sections="sections"
        :chart-data="chartData"
        :fixed-width-bars="70"
        :margin="{ top: 0, bottom: 0, left: 0, right: 0 }"
        has-y-axis
        :y-axis-width="90"
        :has-x-axis="false"
        dynamic-height
        with-tooltips
        show-popovers
        popover-origin-position="column"
        popover-trigger="click"
      >
        <template #popover-content="{ columnData }">
          <InsightsWorkTimeExpenditurePopover :column-data="columnData" />
        </template>
      </AppChartStackedHorizontal>
    </div>
  </AppDialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Insights } from '~/mixins';

import AppChartStackedHorizontal from '~/components/AppChartStackedHorizontal.vue';
import AppDialog from '~/components/AppDialog.vue';
import InsightsWorkTimeExpenditurePopover from '~/components/insights/InsightsWorkTimeExpenditurePopover.vue';

const formatFields = (item) => ({
  non_core: {
    value: item.non_core,
  },
  core: {
    value: item.core,
  },
  unproductive: {
    value: item.unproductive,
  },
});

export default {
  name: 'InsightsWorkTimeExpenditureDialog',
  components: {
    AppChartStackedHorizontal,
    AppDialog,
    InsightsWorkTimeExpenditurePopover,
  },
  mixins: [Insights],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    widgetKey: {
      type: String,
      default: '',
    },
    sections: {
      type: Array,
      required: true,
    },
  },
  emits: ['close'],
  data: () => ({
    limit: 9999, // INFO: Temporary
  }),
  computed: {
    ...mapState(['widgets']),
    widgetName() {
      return `${this.widgetKey}_expanded`;
    },
    isLoading() {
      return this.loadingWidgets && this.loadingWidgets[this.widgetName];
    },
    items() {
      return this.widgets && this.widgets[this.widgetName]
        ? this.widgets[this.widgetName].data || this.widgets[this.widgetName]
        : null;
    },
    chartData() {
      return this.items?.map((item, index) => ({
        ...item,
        // Remove when backend change the tooltip schema
        // We need this mapping for matching the new AppChartStacked schema
        ...formatFields(item),
        label: `${Math.round(item.value * 1000) / 10}% ${item.label}`,
        id: index,
      }));
    },
  },
  async created() {
    await this.fetchWidgets({
      widgetKey: this.widgetKey,
      widgetName: this.widgetName,
      extraQueryParams: {
        limit: this.limit,
      },
    });
  },
  methods: {
    ...mapActions(['fetchWidgets']),
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
